import React, { useState } from 'react'
import styles from './student.module.css';
import Otp from '../../../Component/CampusDrive/studentPanel/otp';
import StudentDetail from '../../../Component/CampusDrive/studentPanel/candidateDetail'
import { campusDriveStudentDetail } from '../../../action/campusDrive';
import { toast } from 'react-toastify';

const Index = () => {
    const [data, setData] = useState(null);

    const onVerifyOtp = (otp) => {
        campusDriveStudentDetail(otp).then((res) => {
            if (res.status) {
                setData(res.result)
            }
            else {
                toast.error(res.error.message || res.error)
            }
        })
    }

    return (
        <React.Fragment>
            {!data && <Otp
                styles={styles}
                onVerifyOtp={(otp) => onVerifyOtp(otp)}
            />}

            {data && < StudentDetail
                data={data}
                styles={styles}
            />}
        </React.Fragment>
    )
}

export default Index